export const actions = {
  set_state: 'coupon_claimers/set_state',
  get_coupon_claimers: 'coupon_claimers/get_coupon_claimers',
  get_coupon_claimers_similar: 'coupon_claimers/get_coupon_claimers_similar',
  get_coupon_claimers_all: 'coupon_claimers/get_coupon_claimers_all'
}
